(function(){
  if(window.__hmLg) return; window.__hmLg=true;
  // Retour arrière : fiche restaurée depuis le cache -> rechargée (bouton jamais grisé)
  window.addEventListener('pageshow',function(e){if(e.persisted&&document.querySelector('[data-lg-product]'))location.reload();});
  var $=function(s,r){return (r||document).querySelector(s)}, $$=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))};
  function money(c,fmt){return (fmt||'CHF {{amount}}').replace(/\{\{\s*amount[a-z_]*\s*\}\}/,(c/100).toFixed(2));}

  // Carrousels (galerie, avis) : défilement + flèches + points
  function slider(root){
    var tr=$('[data-lg-track]',root); if(!tr) return;
    var sl=$$('[data-lg-slide]',tr), dotsBox=$('[data-lg-dots]',root), three=dotsBox&&dotsBox.hasAttribute('data-three');
    var dots=[];
    if(dotsBox){var n=three?Math.min(3,sl.length):sl.length;for(var k=0;k<n;k++){var d=document.createElement('button');d.type='button';d.className='hm-lg-dot';d.setAttribute('aria-label','Diapositive '+(k+1));dotsBox.appendChild(d);dots.push(d);}}
    function idx(){var best=0,bd=1e9;sl.forEach(function(s,i){var dd=Math.abs(s.offsetLeft-tr.scrollLeft);if(dd<bd){bd=dd;best=i;}});return best;}
    function go(i){i=Math.max(0,Math.min(sl.length-1,i));tr.scrollTo({left:sl[i].offsetLeft,behavior:'smooth'});}
    root.hmGo=go;
    function mark(){var i=idx();dots.forEach(function(d,k){var on;if(three){on=(i===0&&k===0)||(i===sl.length-1&&k===dots.length-1)||(i>0&&i<sl.length-1&&k===1);}else{on=k===i;}d.setAttribute('aria-current',on?'true':'false');});}
    var p=$('[data-lg-prev]',root), nx=$('[data-lg-next]',root);
    if(p) p.addEventListener('click',function(){go(idx()-1)});
    if(nx) nx.addEventListener('click',function(){go(idx()+1)});
    dots.forEach(function(d,k){d.addEventListener('click',function(){go(three?(k===0?0:k===dots.length-1?sl.length-1:Math.floor(sl.length/2)):k)})});
    tr.addEventListener('scroll',mark,{passive:true}); mark();
  }

  // Fenêtres (guide des tailles)
  document.addEventListener('click',function(e){
    var o=e.target.closest('[data-lg-open]'); if(o){var m=document.getElementById(o.getAttribute('data-lg-open')); if(m){m.hidden=false;document.body.style.overflow='hidden';} return;}
    var m2=e.target.closest('[data-lg-modal]');
    if(m2&&(e.target===m2||e.target.closest('[data-lg-close]'))){m2.hidden=true;document.body.style.overflow='';}
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape')$$('[data-lg-modal]').forEach(function(m){if(!m.hidden){m.hidden=true;document.body.style.overflow='';}})});

  // Fiche produit
  function product(root){
    var par=root.parentNode, data=JSON.parse(($('[data-lg-variants]',root)||$('[data-lg-variants]',par)).textContent), thumbs=JSON.parse(($('[data-lg-thumbs]',root)||$('[data-lg-thumbs]',par)).textContent);
    var fmt=root.getAttribute('data-money'), ci=+root.getAttribute('data-ci'), si=+root.getAttribute('data-si');
    var offers=$$('[data-lg-offer]',root), form=$('[data-lg-form]',root), gal=$('[data-lg-gallery]',root);
    var c0=root.getAttribute('data-first-color'), s0=root.getAttribute('data-first-size');
    var cur=offers.filter(function(o){return o.getAttribute('aria-pressed')==='true'})[0]||offers[0];
    var st=[{c:c0,s:s0},{c:c0,s:s0}];
    function find(c,s){return data.filter(function(v){return v.o[ci]===c&&v.o[si]===s})[0];}
    function n(o){return +o.getAttribute('data-units')}
    function fr(o){return +o.getAttribute('data-free')}
    function render(){
      offers.forEach(function(o){
        o.setAttribute('aria-pressed',o===cur?'true':'false');
        var tot=0,cmp=0,k=n(o),f=fr(o);
        $$('[data-lg-unit]',o).forEach(function(u,i){
          var v=find(st[i].c,st[i].s)||data[0], p=v.p, c=Math.max(v.c,v.p);
          if(i>=k-f) p=0;
          tot+=p; cmp+=c;
          var up=$('[data-lg-up]',u), uc=$('[data-lg-uc]',u), im=$('[data-lg-uimg]',u), sc=$('[data-lg-sel=c]',u), ss=$('[data-lg-sel=s]',u), ct=$('[data-lg-cthumb]',u);
          if(up) up.textContent=money(p,fmt);
          if(uc){uc.textContent=c>p?money(c,fmt):'';uc.hidden=!(c>p);}
          if(sc&&sc.value!==st[i].c) sc.value=st[i].c;
          if(ss&&ss.value!==st[i].s) ss.value=st[i].s;
          var t=thumbs[st[i].c]; if(im&&t) im.src=t; if(ct&&t) ct.src=t;
        });
        var op=$('[data-lg-op]',o), oc=$('[data-lg-oc]',o);
        if(op) op.textContent=money(tot,fmt);
        if(oc){oc.textContent=cmp>tot?money(cmp,fmt):'';oc.hidden=!(cmp>tot);}
      });
    }
    function jump(){
      var v=find(st[0].c,st[0].s); if(!v||!v.m||!gal||!gal.hmGo) return;
      $$('[data-lg-slide]',gal).forEach(function(s,i){if(+s.getAttribute('data-media')===v.m)gal.hmGo(i)});
    }
    offers.forEach(function(o){
      $('[data-lg-pick]',o).addEventListener('click',function(){cur=o;render();});
      $$('[data-lg-unit]',o).forEach(function(u,i){
        $$('select',u).forEach(function(sel){sel.addEventListener('change',function(){
          if(sel.getAttribute('data-lg-sel')==='c'){st[i].c=sel.value;if(i===0)jump();}else{st[i].s=sel.value;}
          render();
        });});
      });
    });
    form.addEventListener('submit',function(e){
      e.preventDefault(); var btn=$('[data-lg-atc]',form), msg=$('[data-lg-msg]',form); msg.textContent='';
      var agg={}, ok=true;
      for(var i=0;i<n(cur);i++){var v=find(st[i].c,st[i].s); if(!v||!v.a){ok=false;break;} agg[v.id]=(agg[v.id]||0)+1;}
      if(!ok){msg.textContent=form.getAttribute('data-unavailable');return;}
      var items=Object.keys(agg).map(function(id){return {id:+id,quantity:agg[id]}});
      var gv=+root.getAttribute('data-gift-variant');if(cur.getAttribute('data-gift')==='1'&&gv)items.push({id:gv,quantity:1});
      btn.disabled=true;
      fetch((window.Shopify&&Shopify.routes&&Shopify.routes.root||'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})})
        .then(function(r){if(!r.ok)throw 0;return r.json()})
        .then(function(){return window.HomyriaCart.afterAdd(function(){location.href=(window.Shopify&&Shopify.routes&&Shopify.routes.root||'/')+'cart';}).finally(function(){if(window.HomyriaCart.compact)btn.disabled=false;});})
        .catch(function(){btn.disabled=false;msg.textContent=form.getAttribute('data-error');});
    });
    // Date d'expédition : aujourd'hui + 2 jours
    var sh=$('[data-lg-ship]',root);
    if(sh){var d=new Date();d.setDate(d.getDate()+(+sh.getAttribute('data-days')||2));var J=['dimanche','lundi','mardi','mercredi','jeudi','vendredi','samedi'],M=['janvier','février','mars','avril','mai','juin','juillet','août','septembre','octobre','novembre','décembre'];
      sh.textContent=sh.getAttribute('data-tpl').replace('[date]',J[d.getDay()]+' '+d.getDate()+(d.getDate()===1?'er':'')+' '+M[d.getMonth()]);}
    render();
  }
  function init(){
    $$('[data-lg-slider]').forEach(function(el){try{slider(el)}catch(err){console.error('hm-lg',err)}});
    $$('[data-lg-product]').forEach(function(el){try{product(el)}catch(err){console.error('hm-lg',err)}});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',function(){$$('[data-lg-slider]').forEach(slider);});
})();

